export class WebUploadDocumentosPessoaFiltro {
    nrCpf: string;
    nome: string;
    idDocumento: number;
    dtIni: Date;
    dtFim: Date;
}